<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">スタッフマスタ</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-left">
				<div class="uk-form-controls">
					<select id="shop" name="shop" class="uk-select" v-model="sel_shop" v-on:change="changeShop">
						<option value="">店舗を選択してください</option>
						<template v-for="(shop, index) in shops">
							<option :value="shop.id" :key="index">{{shop.name}}</option>
						</template>
					</select>
				</div>
			</div>
			<div class="uk-align-right">
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right uk-overflow-auto">
			<table id="staff_table" class="uk-table uk-table-expand uk-table-striped">
				<thead>
				<tr>
					<th>NO.</th>
					<th>社員番号</th>
					<th>氏名</th>
					<th>表示名</th>
					<th>氏名・表示名変更</th>
					<th>役割</th>
					<th>スキル属性</th>
					<th>管理者</th>
					<th>更新日</th>
					<th>操作</th>
					<th>削除</th>
				</tr>
				</thead>
				<tbody class="tbody">
				<template v-for="(staff, index) in staffs">
					<tr class="row data_row" :key="index" :data-id="staff.id">
						<td>{{ staff.id }}</td>
						<td>{{ staff.staff_number }}</td>
						<td>{{ staff.name }}</td>
						<td>{{ staff.display_name }}</td>
						<td>
							<button class="uk-button uk-button-default" @click="showEditStaffDialog(staff.id)">氏名・表示名変更</button>
						</td>
						<td><span class="uk-button uk-button-default" @click="showEditStaffShopJobPositionDialog(staff.id)">設定</span></td>
						<td><span class="uk-button uk-button-default" @click="showEditStaffShopSkillAttributeDialog(staff.id)">設定</span></td>
						<template v-if="staff.staff_number == staff.shop.admin_staff_number">
							<td><input class="uk-checkbox" name="is_admin" type="checkbox" checked disabled></td>
						</template>
						<template v-else-if="staff.is_admin == true">
							<td><input class="uk-checkbox" name="is_admin" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="is_admin" type="checkbox"></td>
						</template>
						<td>{{ staff.updated_at | moment }}</td>
						<td class="data_row_handle">&#8645;</td>
						<td><span class="uk-icon-button" uk-icon="trash" @click="deleteStaff(staff.id)"></span></td>
					</tr>
				</template>
				</tbody>
			</table>
		</div>
		<div class="uk-container uk-container-expand uk-margin-small-bottom">
			<div class="uk-align-right">
				<button class="uk-button uk-button-primary" @click="saveEditStaff">保存</button>
			</div>
		</div>
		<!--/ Main -->
		<!-- EditStaffJobPositionDialog -->
		<div id="edit_staff_shop_job_position_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">役割設定</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_staff_shop_job_position_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_staff_job_position_form">
					<div class="uk-grid uk-margin-bottom" uk-grid>
						<template v-for="(shop_job_position,index) in shop_job_positions">
							<label class="uk-width-1-3" :key="index">
								<input class="uk-checkbox uk-margin-small-right" name="shop_job_position" type="checkbox" :value="shop_job_position.id" :key="index">
								{{ shop_job_position.display_name }}
							</label>
						</template>
					</div>
					<button type="button" class="uk-width-1-1@l uk-button uk-button-primary" @click="saveEditStaffShopJobPositionDialog">保存</button>
				</form>
			</div>
		</div>
		<!--/ EditStaffJobPositionDialog -->

		<!-- EditStaffJobPositionDialog -->
		<div id="edit_staff_shop_skill_attribute_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">スキル設定</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_staff_shop_skill_attribute_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_staff_skill_attribute_form">
					<div class="uk-grid uk-margin-bottom" uk-grid>
						<template v-for="(shop_skill_attribute,index) in shop_skill_attributes">
							<label class="uk-width-1-3" :key="index">
								<input class="uk-checkbox uk-margin-small-right" name="shop_skill_attribute" type="checkbox" :value="shop_skill_attribute.id" :key="index">
								{{ shop_skill_attribute.skill_attribute.name }}
							</label>
						</template>
					</div>
					<button type="button" class="uk-width-1-1@l uk-button uk-button-primary" @click="saveEditStaffShopSkillAttributeDialog">保存</button>
				</form>
			</div>
		</div>
		<!--/ EditStaffJobPositionDialog -->

		<!-- EditStaffDialog -->
		<div id="edit_staff_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">編集</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_staff_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_staff_form">
					<div class="uk-margin">
						<label class="uk-form-label" for="edit_form_name">氏名 (必須)</label>
						<div class="uk-form-controls">
							<input class="uk-input" id="edit_form_name" name="name" type="text" placeholder="氏名を入力してください" required maxlength="20">
							<template v-if="typeof this.createFormState.errors.name != undefined">
								<template v-for="(error,index) in this.createFormState.errors.name">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="edit_form_display_name">表示名 (必須)</label>
						<div class="uk-form-controls">
							<input class="uk-input" id="edit_form_display_name" name="display_name" type="text" placeholder="表示名を入力してください" required maxlength="8">
							<template v-if="typeof this.createFormState.errors.display_name != undefined">
								<template v-for="(error,index) in this.createFormState.errors.display_name">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="edit_form_staff_number">社員番号 (変更する場合のみ入力)</label>
						<div class="uk-form-controls">
							<input class="uk-input" id="edit_form_staff_number" name="staff_number" type="text" placeholder="社員番号を入力してください" maxlength="20" v-model="input_staffnumber">
							<template v-if="typeof this.createFormState.errors.staff_number != undefined">
								<template v-for="(error,index) in this.createFormState.errors.staff_number">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="edit_form_staff_password">パスワード (変更する場合のみ入力)</label>
						<div class="uk-form-controls">
							<input class="uk-input" id="edit_form_staff_password" name="staff_password" type="password" placeholder="パスワードを入力してください" maxlength="16" v-model="input_password">
							<template v-if="typeof this.createFormState.errors.staff_password != undefined">
								<template v-for="(error,index) in this.createFormState.errors.staff_password">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<div class="uk-margin">
						<label class="uk-form-label" for="edit_form_staff_password_once">パスワード確認 (変更する場合のみ入力)</label>
						<div class="uk-form-controls">
							<input class="uk-input" id="edit_form_staff_password_once" name="staff_password_once" type="password" placeholder="パスワードをもう一度入力してください" maxlength="16" v-model="input_passwordonce">
							<template v-if="typeof this.createFormState.errors.staff_password_once != undefined">
								<template v-for="(error,index) in this.createFormState.errors.staff_password_once">
									<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
								</template>
							</template>
						</div>
					</div>
					<button type="button" class="uk-width-1-1@l uk-button uk-button-primary" @click="saveEditStaffDialog">保存</button>
				</form>
			</div>
		</div>
		<!--/ EditStaffDialog -->

	</div>
</template>

<script>
	import RoleService from '@/services/RoleService'
	import Staff from '@/api/Staff'
	import StaffAuth from '@/api/StaffAuth'
	import Role from '@/api/Role'
	import ShopJobPosition from '@/api/ShopJobPosition'
	import StaffShopJobPosition from '@/api/StaffShopJobPosition'
	import StaffShopSkillAttribute from '@/api/StaffShopSkillAttribute'
	import ShopSkillAttribute from '@/api/ShopSkillAttribute'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import Sortable from 'sortablejs'
	import Shop from '@/api/Shop'
	import CgtManageAuth from '@/api/CgtManageAuth'

	export default {
		name: 'ShopStaffMasterPage',
		comments: [],
		data () {
			return {
				need_confirm_alert: false,
				createFormState: {
					errors: []
				},
				staffs: [],
				shop_job_positions: [],
				shop_skill_attributes: [],
				current_staff: null,
				shops: [],
				sel_shop: '',
				input_staffnumber: '',
				input_password: '',
				input_passwordonce: ''
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			onInputPassword (event) {
				if (event.target.value.indexOf(' ') !== -1) {
					alert('パスワードに空白は含める事ができません')
					$('#create_form_password').val('')
				}
			},
			showEditStaffDialog (id) {
				let self = this

				$('#edit_staff_dialog').data('id', id)

				let params = new URLSearchParams()
				params.append('id', id)

				Staff.one(params).then(function (response) {
					let data = response.data.data

					$('#edit_form_name').val(data.name)
					$('#edit_form_display_name').val(data.display_name)

					self.input_staffnumber = ''
					self.input_password = ''
					self.input_passwordonce = ''

					UIkit.modal($('#edit_staff_dialog'), {container: '#app div', bgClose: false}).show()
				}).catch(function (error) {
					self.createFormState.errors = error.response.data.errors
				})
			},
			saveEditStaffDialog () {
				let self = this

				let id = $('#edit_staff_dialog').data('id')

				let proc_flg = true

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('name', $('#edit_form_name').val())
				params.append('display_name', $('#edit_form_display_name').val())

				if (self.input_staffnumber != '') {
					params.append('staff_number', self.input_staffnumber)
					console.log(self.input_staffnumber)
				}
				if (self.input_password != '') {
					console.log(self.input_password)
					if (self.input_passwordonce != '') {
						console.log(self.input_passwordonce)
						// パスワード一致チェック
						if (self.input_password == self.input_passwordonce) {
							// 一致する
							params.append('password', self.input_password)
						} else {
							// 一致しない
							let errmsg = {staff_password_once: {input: '入力されたパスワードが一致しません'}}
							self.createFormState.errors = errmsg
							proc_flg = false
						}
					} else {
						// 再入力していない
						let errmsg = {staff_password_once: {once: '確認のためパスワードを再入力してください'}}
						self.createFormState.errors = errmsg
						proc_flg = false
					}
				}
				if (proc_flg) {
					Staff.update(params).then(function (response) {
						alert('保存完了')
						// location.reload()
						self.loadStaffs()
						self.loadShopJobPositions()
						self.loadShopSkillAttributes()
						UIkit.modal($('#edit_staff_dialog')).hide()
					}).catch(function (error) {
						self.createFormState.errors = error.response.data.errors
					})
				}
			},
			returnButton: function () {
				if ($('.data_row_before_save').length > 0) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						this.$router.push('/cgt_manage')
						location.reload()
					}
				} else {
					this.$router.push('/cgt_manage')
					location.reload()
				}
			},
			clickLogoutButton () {
				let self = this

				CgtManageAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/cgt_manage/login')
								location.reload()
							// })
						// })
					// })
				})
			},
			moveDialogs () {
				$('#edit_staff_shop_job_position_dialog').appendTo('body')
				$('#edit_staff_shop_skill_attribute_dialog').appendTo('body')
			},
			bulkCheckAction () {
				let checked = $('#bulk_check_action').prop('checked')
				$('#staff_table tbody .data_row [name="status"]').prop('checked', checked)
				$('#staff_table tbody .data_row').addClass('data_row_before_save')
			},
			saveEditStaffShopSkillAttributeDialog () {
				let self = this
				let staff_id = $('#edit_staff_shop_skill_attribute_dialog').data('id')

				let params = new URLSearchParams()
				params.append('id', staff_id)

				Staff.one(params).then(function (response) {
					let staff = response.data.data

					let params = new URLSearchParams()
					params.append('staff_id', staff.id)

					StaffShopSkillAttribute.delete(params).then(function (response) {
						self.need_confirm_alert = false

						$('#edit_staff_shop_skill_attribute_dialog input[type="checkbox"]:checked').each(function () {
							let params = new URLSearchParams()
							params.append('staff_id', staff.id)
							params.append('shop_skill_attribute_id', $(this).val())

							StaffShopSkillAttribute.create(params).then(function (response) {
								self.need_confirm_alert = false
							})
						})
					})

					alert('保存完了')
					UIkit.modal($('#edit_staff_shop_skill_attribute_dialog')).hide()
				})
			},
			showEditStaffShopSkillAttributeDialog (id) {
				$('#edit_staff_shop_skill_attribute_dialog').data('id', id)
				$('#edit_staff_shop_skill_attribute_dialog input[type="checkbox"]').prop('checked', false)

				let params = new URLSearchParams()
				params.append('staff_id', id)
				params.append('status', 0)

				StaffShopSkillAttribute.all(params).then(function (response) {
					response.data.data.forEach(function (value) {
						$('#edit_staff_shop_skill_attribute_dialog input[value="' + value.shop_skill_attribute_id + '"]').prop('checked', true)
					})

					UIkit.modal($('#edit_staff_shop_skill_attribute_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			saveEditStaffShopJobPositionDialog () {
				this.need_confirm_alert = false

				let self = this
				let staff_id = $('#edit_staff_shop_job_position_dialog').data('id')

				let params = new URLSearchParams()
				params.append('id', staff_id)

				Staff.one(params).then(function (response) {
					let staff = response.data.data

					let params = new URLSearchParams()
					params.append('staff_id', staff.id)

					StaffShopJobPosition.delete(params).then(function (response) {
						$('#edit_staff_shop_job_position_dialog input[type="checkbox"]:checked').each(function () {
							let params = new URLSearchParams()
							params.append('staff_id', staff.id)
							params.append('shop_job_position_id', $(this).val())

							StaffShopJobPosition.create(params).then(function (response) {
								self.need_confirm_alert = false
							})
						})
					})

					alert('保存完了')
					UIkit.modal($('#edit_staff_shop_job_position_dialog')).hide()
				})
			},
			showEditStaffShopJobPositionDialog (id) {
				$('#edit_staff_shop_job_position_dialog').data('id', id)
				$('#edit_staff_shop_job_position_dialog input[type="checkbox"]').prop('checked', false)

				let params = new URLSearchParams()
				params.append('staff_id', id)

				StaffShopJobPosition.all(params).then(function (response) {
					response.data.data.forEach(function (value) {
						$('#edit_staff_shop_job_position_dialog input[value="' + value.shop_job_position_id + '"]').prop('checked', true)
					})

					UIkit.modal($('#edit_staff_shop_job_position_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			deleteStaff (id) {
				let self = this
				let answer = window.confirm('本当に削除しますか？')

				if (answer) {
					let params = new URLSearchParams()
					params.append('id', id)

					Staff.can_delete(params).then(function (response) {
						if (response.data.data) {
							Staff.delete(params).then(function (response) {
								// location.reload()
								self.loadStaffs()
								self.loadShopJobPositions()
								self.loadShopSkillAttributes()
							})
						} else {
							alert('このスタッフは削除できません')
						}
					})
				}
			},
			saveEditStaff () {
				let length = $('#staff_table .data_row_before_save').length

				$('#staff_table .data_row').each(function (i) {
					let index = i
					let order_by = i

					let id = $(this).data('id')
					let is_admin = false

					if ($(this).find('[name="is_admin"]').prop('checked')) {
						is_admin = true
					}

					let params = new URLSearchParams()
					params.append('id', id)
					params.append('is_admin', is_admin)
					params.append('order_by', order_by)

					Staff.update(params).then(function () {
						if (i + 1 == length) {
							alert('保存完了')
							// location.reload()
							self.loadStaffs()
							self.loadShopJobPositions()
							self.loadShopSkillAttributes()
						}
					})
				})
			},
			loadShopSkillAttributes () {
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', self.sel_shop)
				params.append('status', 0)

				ShopSkillAttribute.all(params).then(function (response) {
					self.shop_skill_attributes = response.data.data
				})
			},
			loadShopJobPositions () {
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', self.sel_shop)
				params.append('status', 0)

				ShopJobPosition.all(params).then(function (response) {
					self.shop_job_positions = response.data.data
				})
			},
			loadStaffs () { // スタッフ情報を取得する
				let self = this
				let params = new URLSearchParams()
				params.append('shop_id', self.sel_shop)

				Staff.all(params).then(function (response) {
					self.staffs = response.data.data
				})
			},
			registerDataChangeEvent () { // データを変更した時のイベント登録
				$(document).on('change', '#staff_table .data_row .uk-checkbox', function () {
					if ($(this).text() != $(this).data('first')) {
						$(this).closest('.data_row').addClass('data_row_before_save')
					}
				})
			},
			loadShops () {
				let self = this
				Shop.all().then(function (response) {
					self.shops = response.data.data
				})
			},
			changeShop () {
				// セレクトボックスの店舗を変更した
				let self = this
				self.loadStaffs()
				self.loadShopJobPositions()
				self.loadShopSkillAttributes()
			}
		},
		created () {
		},
		beforeMount () {
		},
		mounted () {
			// this.loadStaffs() // スタッフ情報を取得
			this.registerDataChangeEvent() // データ変更に関するイベント登録
			// this.loadShopJobPositions()
			// this.loadShopSkillAttributes()
			this.moveDialogs()
			this.loadShops() // 店舗情報取得

			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_cgt_manage != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})

			/* StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data
			}) */

			$('#edit_staff_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_staff_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_staff_dialog')).hide()
				}
			})

			$('#edit_staff_shop_job_position_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_staff_shop_job_position_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_staff_shop_job_position_dialog')).hide()
				}
			})

			$('#edit_staff_shop_skill_attribute_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_staff_shop_skill_attribute_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_staff_shop_skill_attribute_dialog')).hide()
				}
			})

			$('#edit_staff_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_staff_shop_job_position_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_staff_shop_skill_attribute_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			Sortable.create($('#staff_table .tbody')[0], {
				handle: '.data_row_handle',
				draggable: '.data_row',
				dragoverBubble: true,
				onEnd: function (event) {
					$(event.item).addClass('data_row_before_save')
				},
				onMove: function (event) {
					$(event.item).addClass('data_row_before_save')
				}
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#staff_table {
		width: 100%;
		overflow-x: auto;

		thead {
			tr {
				th {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
					white-space: nowrap;
				}
			}
		}

		tbody {
			tr {
				td {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
					white-space: nowrap;

					&:focus {
						background: #FFF;
					}
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/CgtManageStaffMasterPage.vue